import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

const OrdersRouter = {
  path: '/orders',
  component: Management,
  redirect: '/orders/list',
  children: [
    {
      path: 'list',
      component: () => import('@/views/orders/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listOrders
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/orders/ListTable'),
          meta: {
            auth: Auth.listOrders,
            tabName: 'all'
          }
        },
        {
          path: 'in_progress',
          component: () => import('@/views/orders/ListTable'),
          meta: {
            auth: Auth.listOrders,
            tabName: 'in_progress'
          }
        },
        {
          path: 'unpaid',
          component: () => import('@/views/orders/ListTable'),
          meta: {
            auth: Auth.listOrders,
            tabName: 'unpaid'
          }
        },
        {
          path: 'settled',
          component: () => import('@/views/orders/ListTable'),
          meta: {
            auth: Auth.listOrders,
            tabName: 'settled'
          }
        },
        {
          path: 'unhealthy',
          component: () => import('@/views/orders/ListTable'),
          meta: {
            auth: Auth.showOrderDebugInfo,
            tabName: 'unhealthy'
          }
        }
      ]
    },
    {
      path: ':id',
      component: () => import('@/views/orders/DetailLayout'),
      redirect: ':id/detail',
      meta: {
        auth: Auth.showOrder
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/orders/details/Detail'),
          meta: {
            auth: Auth.showOrder,
            tabName: 'detail'
          }
        },
        {
          path: 'state_analysis',
          component: () => import('@/views/orders/details/StateAnalysis'),
          meta: {
            auth: Auth.showOrder,
            tabName: 'state_analysis'
          }
        }
        // {
        //   path: 'order_analysis',
        //   component: () => import('@/views/orders/details/OrderAnalysis'),
        //   meta: {
        //     auth: Auth.showOrder,
        //     tabName: 'order_analysis'
        //   }
        // }
      ]
    }
  ]
}

export default OrdersRouter
